@if (config) {
    <ws-modal-wrapper [headerLabel]="config.year + ' Revisions'"
                      acceptLabel="Save"
                      [disableSave]="isBusy"
                      (save)="save()"
                      (cancel)="modalRef.hide()">
        @if (isBusy) {
            <div class="text-center">
                <i class="fa fa-spinner fa-spin fa-2x"></i> Savings changes...
            </div>
        }
        @if (!isBusy) {
            <div>
                <h5>Drag & drop the revisions below to order them from the earliest (top) to the most recent
                    (bottom).</h5>
                <bs-sortable [(ngModel)]="config.assessments" [itemTemplate]="itemTemplate" itemClass="wsSortable__item" itemActiveClass="wsSortable__item--active"
                             wrapperClass="wsSortable">
                </bs-sortable>
            </div>
        }
    </ws-modal-wrapper>
}

<ng-template #itemTemplate let-item="item" let-index="index">
    <span class="label label-success" style="color: inherit;">REVISION {{ index + 1 }}</span>
    <div style="padding-left: 8px; display: inline-block; vertical-align: middle;">
        <strong>{{ item.value.description }}</strong>
    </div>
</ng-template>
